import Landing from "../components/container/Landing";
import BlogPosts from "../components/container/BlogPosts";
import BlogPost from "../components/container/BlogPost";
import Solutions from "../components/container/Solutions";
import SolutionCategory from "../components/container/SolutionCategory";
import Solution from "../components/container/Solution";
import Contact from "../components/container/Contact";
import DemoRequest from "../components/container/DemoRequest";
import Methodologies from "../components/container/Methodologies";
import Methodology from "../components/container/Methodology";
import AboutUs from "../components/container/AboutUs";
import Documents from "../components/container/Documents";
import DocumentCategory from "../components/container/DocumentCategory";
import Document from "../components/container/Document";
import FAQs from "../components/container/FAQs";
import FAQ from "../components/container/FAQ";
import CookiePolicy from "../components/container/CookiePolicy";
import GDPR from "../components/container/GDPR";


export default [
  {
    component: Landing,
    path: '/',
    //exact: true
  }
];
